



























import { Component, Prop, Vue } from 'vue-property-decorator';
import DetailField from '@/components/DetailField.vue';

@Component({
  components: { DetailField }
})
export default class EventOverview extends Vue {
  @Prop(Array) public readonly events!: object[];
  @Prop(String) public readonly eventFieldName!: string;
  @Prop(Array) public readonly eventMap!: object[];

}
